import styled from 'styled-components';

import ActionButton from 'components/action-button';

export const Container = styled.div`
  margin: 2rem auto 1rem auto;
  text-align: center;
`;

export const Instructions = styled.div`
  margin-bottom: 2rem;
`;

export const Button = styled(ActionButton)`
  margin: auto;
`;
